import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuId: null,
    menuData: [],
    // 漢堡選單及側開選單開關共用
    showNav: false,
  },
  mutations: {
    SET_MENUDATA(state, payload) {
      state.menuData = payload;
      state.menuId = payload[0].power_id;
    },
    SET_MENUID(state, payload) {
      state.menuId = payload;
    },
    SET_SHOWNAV(state, payload) {
      state.showNav= payload;
    },
  },
  actions: {},
  modules: {},
});
